export const audizioneCamera2025 = {
  id: 'static-audizione-camera-2025',
  slug: 'audizione-camera-2025',
  title: 'UNASCA in audizione alla Camera: digitalizzazione, trasparenza e sicurezza nel mercato dei veicoli',
  excerpt: 'Il 2 luglio 2025, UNASCA è intervenuta in audizione presso la Commissione Politiche Ue sulla digitalizzazione dei documenti di immatricolazione e revisione dei veicoli.',
  body: `
    <div style="background: white; color: #001510; padding: 2rem; border-radius: 12px; margin: 2rem 0; text-align: center; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); border: 2px solid #00bf8f;">
      <h2 style="font-size: 2rem; margin-bottom: 1rem; font-weight: 600; color: #001510;">
        <i class="fas fa-landmark"></i> Audizione presso la Commissione Politiche Ue
      </h2>
      <p style="color: #2c3e50; font-size: 1.1rem; line-height: 1.6;">
        Il 2 luglio 2025, UNASCA è intervenuta in audizione presso la Commissione Politiche Ue, nell'ambito dell'esame sulla proposta europea relativa alla digitalizzazione dei documenti di immatricolazione e revisione dei veicoli.
      </p>
    </div>

    <p>Un'occasione importante per rappresentare le istanze degli studi di consulenza automobilistica e delle agenzie pratiche auto, da anni al centro del processo di emissione e gestione della documentazione di circolazione.</p>

    <h2><i class="fas fa-key"></i> I Punti Chiave dell'Intervento UNASCA</h2>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-mobile-alt"></i> Digitalizzazione e Carta Fisica
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Pur riconoscendo i vantaggi della digitalizzazione, è stata sottolineata l'esigenza di <strong>mantenere disponibile la carta di circolazione fisica</strong>
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Una larga fascia della popolazione non è ancora digitalmente autonoma
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ La coesistenza di formato digitale e fisico garantisce accessibilità per tutti
        </li>
      </ul>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-flag-checkered"></i> L'Italia all'Avanguardia
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ L'Italia è già molto avanti rispetto ad altri paesi europei nella gestione dei dati veicolari
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ I nostri documenti di circolazione sono tra i <strong>più completi e affidabili</strong>
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Spesso i documenti esteri risultano carenti di informazioni essenziali
        </li>
      </ul>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-network-wired"></i> Sistema Eucaris e Interoperabilità
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Riflessione sul registro europeo "Move Up" e potenziamento del sistema Eucaris esistente
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Il sistema Eucaris permette già lo scambio di informazioni tra Stati
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Criticità: se non tutti i paesi aderiscono, il sistema risulta <strong>inefficace e suscettibile di abusi</strong>
        </li>
      </ul>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-tachometer-alt"></i> Contrasto alle Frodi sul Chilometraggio
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ In Europa il <strong>15% delle auto vendute</strong> ha chilometraggi falsificati (11% in Italia)
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Conseguenti rischi per la sicurezza e l'affidabilità dei veicoli
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Proposta: sfruttare il momento della compravendita come "punto di verità"
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Accesso alle banche dati per certificare i chilometri reali
        </li>
      </ul>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-globe-europe"></i> Nazionalizzazione Veicoli Esteri
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Quando si importano veicoli dall'estero, i dati sul chilometraggio sono spesso assenti
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Le agenzie incaricate, in quanto soggetti che svolgono un <strong>ruolo pubblico</strong>, possono contribuire alla registrazione
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Obiettivo: garantire maggiore trasparenza nel mercato
        </li>
      </ul>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-robot"></i> Digitalizzazione e Intelligenza Artificiale
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Monito sull'eccesso di automazione
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ La digitalizzazione è utile, ma deve essere sempre accompagnata da <strong>figure professionali di riferimento</strong>
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          ✓ Necessità di soggetti in grado di assumersi la responsabilità della veridicità dei dati e delle procedure
        </li>
      </ul>
    </div>

    <blockquote style="background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%); border-left: 4px solid #FFD700; padding: 1.5rem; margin: 2rem 0; border-radius: 0 12px 12px 0; font-style: italic; font-size: 1.1rem; color: #2c3e50;">
      La digitalizzazione va benissimo, ma deve essere controllata. Altrimenti rischieremmo qualsiasi tipo di fatto illecito.
    </blockquote>

    <h2><i class="fas fa-balance-scale"></i> Conclusioni</h2>
    
    <p>L'intervento di UNASCA ha offerto una prospettiva concreta e tecnica su come la digitalizzazione debba procedere in equilibrio con le competenze dei professionisti del settore. Una transizione efficace richiede:</p>
    
    <ul style="margin-left: 2rem; margin-bottom: 2rem;">
      <li><strong>Infrastrutture solide</strong> e sistemi affidabili</li>
      <li><strong>Cooperazione europea</strong> effettiva tra tutti gli Stati membri</li>
      <li><strong>Riconoscimento del valore umano</strong> nel controllo e nella gestione dei dati</li>
      <li><strong>Trasparenza</strong> nel mercato dei veicoli usati</li>
    </ul>

    <div style="text-align: center; margin: 2rem 0;">
      <video controls style="width: 100%; max-width: 800px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
        <source src="/images/Video WhatsApp 2025-07-02 ore 20.20.09_dab334be.mp4" type="video/mp4">
        Il tuo browser non supporta il tag video.
      </video>
      <p style="margin-top: 1rem; font-size: 0.9rem; color: #6c757d; text-align: center;">
        <i class="fas fa-info-circle"></i> Video dell'intervento UNASCA presso la Commissione Politiche Ue
      </p>
    </div>
  `,
  featuredImage: '/images/camera_digitale.jpg',
  category: {
    id: 'normative',
    name: 'Normative',
    slug: 'normative',
    color: '#F59E0B'
  },
  tags: ['Audizione', 'Camera dei Deputati', 'Digitalizzazione', 'Politiche UE', 'Trasparenza'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-07-02T10:00:00Z',
  createdAt: '2025-07-02T10:00:00Z',
  updatedAt: '2025-07-02T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 6
};

